import { Component, inject, OnInit, signal } from '@angular/core';

import { RouterModule } from '@angular/router';
import { LoaderComponent } from '@mic-ac/ui-kit';
import { AuthServiceService } from '../../../../core/services/auth-service/auth-service.service';
import { UserReqComponent } from '../user-req/user-req.component';
import { MyAreaPageComponent } from '../user-published-data/user-init-page.component';
import { ResponseUser } from '../../../../shared/models/utente';

@Component({
    selector: 'app-user-decision',
    imports: [RouterModule, UserReqComponent, MyAreaPageComponent, LoaderComponent],
    template: `
    @if (loading()) {
      <div class="flex justify-center items-center" >
        <lib-loader></lib-loader>
      </div>
    } @else if (userProfile().element?.micAuthorized) {
      <ng-container>
        <app-user-init-page></app-user-init-page>
      </ng-container>
    } @else {
        <app-user-req></app-user-req>
    }
  `
})
export class UserDecisionComponent implements OnInit {
  userProfile = signal<ResponseUser>({} as ResponseUser);
  loading = signal(true);

  ngOnInit(): void {
    this.getProfile();
  }

  #auth = inject(AuthServiceService);

  getProfile() {
    this.#auth.myProfile().subscribe({
      next: (res) => {
        this.userProfile.set(res);
        this.#auth.setUser(res);
        this.loading.set(false);
      },
      error: (err) => {
        this.loading.set(false);
      },
    });
  }
}
